import { render, staticRenderFns } from "./SelectTreatmentsMultiDialog.vue?vue&type=template&id=dfbf6ed2&scoped=true"
import script from "./SelectTreatmentsMultiDialog.vue?vue&type=script&lang=js"
export * from "./SelectTreatmentsMultiDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbf6ed2",
  null
  
)

export default component.exports